<template>
  <div class="card">
    <div class="card-body">
      <div v-if="loginError" class="alert alert-danger">Contraseña incorrecta</div>
      <div v-if="errorNews" class="alert alert-danger">Las contraseñas no coinciden</div>
      <div class="text-center mb-4 mt-1">
        <img alt="Vue logo" height="60" src="../../../assets/logo-rentik.svg">
      </div>
      <form @submit.prevent="submit()">
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label for="otp">Código de confirmación</label>
              <input type="text" class="form-control" id="otp" v-model.trim="v$.otp.$model">
              <div v-if="v$.otp.$dirty">
                <small class="form-text text-danger" v-if="!v$.otp.required">Campo requerido</small>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label for="newPassword">Contraseña nueva</label>
              <input type="password" class="form-control" id="newPassword"
                v-model.trim="v$.newPassword.$model">
              <div v-if="v$.newPassword.$dirty">
                <small class="form-text text-danger" v-if="!v$.newPassword.required">Campo requerido</small>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label for="confirmPassword">Confirmar contraseña nueva</label>
              <input type="password" class="form-control" id="confirmPassword"
                v-model.trim="v$.confirmPassword.$model">
              <div v-if="v$.confirmPassword.$dirty">
                <small class="form-text text-danger" v-if="!v$.confirmPassword.required">Campo requerido</small>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-12 text-center">
            <button class="btn btn-primary" v-bind:class="{ disabled: v$.$invalid }"
              :disabled="v$.$invalid" @click="submit()">
              <span v-if="!loading">Confirmar</span>
              <img v-if="loading" src="../../../assets/loader.svg" height="20" alt="">
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import axios from 'axios';

export default {
  name: 'ChangePassword',
  setup() {
    return { v$: useVuelidate() }
  },
  data() {
    return {
      user: '',
      confirmPassword: '',
      otp: '',
      newPassword: '',
      loginError: false,
      loading: false,
      errorNews: false
    };
  },
  validations() {
    return {
      confirmPassword: {
        required
      },
      otp: {
        required
      },
      newPassword: {
        required
      },
    }
  },
  methods: {
    submit() {
      this.loading = true;
      if (this.confirmPassword == this.newPassword) {
        let bodyToSend = {
          username: this.$cookies.get('username'),
          confirmationCode:this.otp,
          password: this.newPassword,
          userType: "BACKOFFICE"
        }
        axios.post('/user/confirmResetPassword', bodyToSend)
          .then((res) => {
            console.log(res)
            this.loginError = false;
            this.loading = false;
            this.errorNews = false;
            this.otp = '';
            this.newPassword = '';
            this.confirmPassword = '';
            this.$router.push({ name: 'home' })
          })
      } else {
        this.loading = false;
        this.errorNews = true;
        this.loginError = false;
      }
    },
  },
}
</script>

<style lang="scss">

</style>
